// Navigation Processing Status Constants
// Must match the backend enum values from NavigationProcessingStatus.cs

export const NavigationStatus = {
  NOT_PROCESSED: 0,
  START_PROCESSING: 5,
  PROCESSING: 10,
  ONLINE_PROCESSING: 15,
  COMPLETED: 20,
  FAILED: 30
};

export const NavigationStatusNames = {
  [NavigationStatus.NOT_PROCESSED]: 'NotProcessed',
  [NavigationStatus.START_PROCESSING]: 'StartProcessing',
  [NavigationStatus.PROCESSING]: 'Processing',
  [NavigationStatus.ONLINE_PROCESSING]: 'OnlineProcessing',
  [NavigationStatus.COMPLETED]: 'Completed',
  [NavigationStatus.FAILED]: 'Failed'
};

export const isProcessingStatus = (status) => {
  return status === NavigationStatus.START_PROCESSING ||
         status === NavigationStatus.PROCESSING ||
         status === NavigationStatus.ONLINE_PROCESSING;
};

// Check if navigation data is NOT yet available (still processing, no data to display)
export const isBlockingProcessingStatus = (status) => {
  return status === NavigationStatus.START_PROCESSING ||
         status === NavigationStatus.PROCESSING;
};

// Check if navigation data IS available (completed or streaming with data)
export const isNavigationDataAvailable = (status) => {
  return status === NavigationStatus.COMPLETED ||
         status === NavigationStatus.ONLINE_PROCESSING;
};

export const isCompletedStatus = (status) => {
  return status === NavigationStatus.COMPLETED;
};

export const isFailedStatus = (status) => {
  return status === NavigationStatus.FAILED;
};